var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGigByDriverArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "10px",
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "diagram-arrow-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gig-List---View-by-Driver",
    transform: "translate(-428.000000, -394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gig-List-Cell-2",
    transform: "translate(286.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gig-Info",
    transform: "translate(38.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diagram-arrow-right",
    transform: "translate(96.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,4 C0.5,3.44771525 0.94771525,3 1.5,3 L11,3 L11,0.674 C11,0.492666667 11.1086667,0.445333333 11.2413333,0.568666667 L15.3406667,4.63533333 C15.4427265,4.7299524 15.500732,4.86282756 15.500732,5.002 C15.500732,5.14117244 15.4427265,5.2740476 15.3406667,5.36866667 L11.2413333,9.43533333 C11.108,9.55866667 11,9.51133333 11,9.33 L11,7 L1.5,7 C0.94771525,7 0.5,6.55228475 0.5,6 L0.5,4 Z",
    id: "Shape",
    className: "icon-fill"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigByDriverArrow);
export default __webpack_public_path__ + "static/media/gig-by-driver-arrow.59472388b300a94f5f4b3965d81b7c25.svg";
export { ForwardRef as ReactComponent };